import HubOutlinedIcon from "@mui/icons-material/HubOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "integrations", spoke: "integrations", title: "Integrations", icon: HubOutlinedIcon, order: 62, entries: [
  { label: "Integration center", to: "/app/integrations", permission: "integrations.connection.view" },
  { label: "Webhooks", to: "/app/integrations/webhooks", permission: "integrations.webhook.view" },
  { label: "Events & replay", to: "/app/integrations/events", permission: "integrations.event.view" },
  { label: "EDI", to: "/app/integrations/edi", permission: "integrations.edi.view" },
  { label: "Developer portal", to: "/app/integrations/developers" },
] });
